import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { CreateMessageDialog } from "../../../modules/merchant/admin/messages/components/CreateMessageDialog"
import { ServiceCenterCreateMessageDialog } from "../../../modules/serviceCenter/admin/messages/components/ServiceCenterCreateMessageDialog"
import { useOrderDialogUrlState } from "../../components/createOrder/hooks/useOrderDialogUrlState"
import { createTopBarNewMenuItem } from "../../components/topBarNewButtonMenu/topBarNewMenuItems"
import { TopBarNewButton } from "../../components/topBarNewButtonMenu/TopBarNewButton"
import { CreateOrderType } from "../../components/createOrder/helpers"
import {
    TopBarNewButtonMenu,
    UserActionsMenuItemConfig,
} from "../../components/topBarNewButtonMenu/TopBarNewButtonMenu"
import {
    MERCHANT_ACCOUNTING_PRODUCT_SALES,
    MERCHANT_ADMIN_PRODUCTS_LIST_ROUTE,
    MESSAGES_ROUTE,
} from "../../../constants/routes"
import { TopBarNewMenuShortcutConfig } from "../../components/topBarNewButtonMenu/TopBarNewButtonShortcuts"
import { useMatchEnvironment } from "../../../modules/environment/envHooks"
import { EnvironmentType } from "../../../modules/environment/envTypes"

type CreateOrderButtonProps = {
    showDropdownMenu?: boolean
    isServiceCenter?: boolean
}

export function MainTopBarNewButton({ showDropdownMenu, isServiceCenter }: CreateOrderButtonProps) {
    const { openDialog } = useOrderDialogUrlState()
    const navigate = useNavigate()
    const isCreateOrderEnabledForSC = useMatchEnvironment([EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo])

    const [isCreateMessageOpen, setIsCreateMessageOpen] = useState(false)

    const handleCreateOrder = (activeOrderTab?: CreateOrderType) => {
        openDialog({ activeOrderTab })
    }

    const handleOpenCreateMessage = () => {
        setIsCreateMessageOpen(true)
    }

    const handleCloseCreateMessage = () => {
        setIsCreateMessageOpen(false)
    }

    if (showDropdownMenu) {
        const items: UserActionsMenuItemConfig[] = [
            createTopBarNewMenuItem("push-message", handleOpenCreateMessage),
        ]

        if (!isServiceCenter || isCreateOrderEnabledForSC) {
            const it = createTopBarNewMenuItem("meeting-service", () => handleCreateOrder(CreateOrderType.MEETING_SERVICE))
            items.push(it)
        }

        const shortcuts: ReadonlyArray<TopBarNewMenuShortcutConfig> | undefined = isServiceCenter
            ? undefined
            : [
                  {
                      id: "accounting-product-sales",
                      labelId: "top-bar-new-menu-shortcut-accounting",
                      onClick: () => navigate(MERCHANT_ACCOUNTING_PRODUCT_SALES),
                  },
                  {
                      id: "manage-products",
                      labelId: "top-bar-new-menu-shortcut-manage-products",
                      onClick: () => navigate(MERCHANT_ADMIN_PRODUCTS_LIST_ROUTE),
                  },
                  {
                      id: "manage-push-messages",
                      labelId: "top-bar-new-menu-shortcut-manage-push-messages",
                      onClick: () => navigate(MESSAGES_ROUTE),
                  },
              ]

        const MessageDialog = isServiceCenter ? ServiceCenterCreateMessageDialog : CreateMessageDialog

        return (
            <>
                <TopBarNewButtonMenu items={items} shortcuts={shortcuts} />
                {isCreateMessageOpen && <MessageDialog open={isCreateMessageOpen} onClose={handleCloseCreateMessage} />}
            </>
        )
    }

    return <TopBarNewButton onClick={() => handleCreateOrder()} />
}
